// Reads the promo code out of the URL (…/?promo=flash25).
//
// Kept in its own module so pricing.js stays free of browser globals — the
// promo *rules* (lookup, expiry, eligibility) live in pricing.js alongside the
// rest of the money math; this file only answers "what did the link say?".
export function readPromoCodeFromUrl() {
  if (typeof window === 'undefined' || !window.location) return null;
  const code = new URLSearchParams(window.location.search).get('promo');
  return code ? code.trim() : null;
}
